import { useState, useEffect } from 'react';
import { axiosInstanceB2B, mailFormat, renderNumber } from '@share/utils';
import image from '@assets/images/heros/public-homepage2.jpg';
import image1 from '@assets/images/home/chicago.jpg';
import image2 from '@assets/images/home/sanfrancisco.jpg';
import { isEmpty } from 'lodash';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ILoginState } from '@share/store/slices';
import {  Form, Input } from 'antd';
import { FormattedMessage } from 'react-intl';
import './style.scss';

const Hero = () => {
  const [form] = Form.useForm();
  const [savings, setSavings] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState<string | null>(null);
  const history = useHistory();

  const login = useSelector((state: { loginStore: ILoginState }) => state.loginStore);

  const fetchSavings = async () => {
    setLoading(true);

    try {
      const response = await axiosInstanceB2B.get(`/bookings/bookings/saving/sum`);
      const data = response.data;

      setSavings(renderNumber(data.customerSavingAmount, 2));
    } catch (_e) {}

    setLoading(false);
  };

  useEffect(() => {
    const userStorage = login.user;
    const isLogged = !!userStorage;

    if (isLogged) {
      history.push(`/${login.account?.name}/dashboard`);
    }

    fetchSavings();

    const timerTimeout = setInterval(() => fetchSavings(), 30000);

    return () => {
      if (timerTimeout) {
        clearTimeout(timerTimeout);
      }
    };
  }, []);

  const handleBlur = () => {
    const email = form.getFieldValue('email');
    if (!email) {
      setEmailError('Please enter your email address.');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value;
    if (!email) {
      setEmailError('Please enter your email address.');
    } else {
      setEmailError(null);
    }
  };

  const onFinish = (values: any) => {
    if (!values.email) {
      setEmailError('Please enter your email address.');
    } else if (!mailFormat.test(values.email)) {
      setEmailError('Please enter a valid email address.');
    } else {
     history.push(`${login.account?.name}/register?email=${encodeURIComponent(values.email)}`);
    }
  };

  return (
    <section className="pt-3 pt-lg-5 custom-hero">
      <div className="container">
        <div className="row g-4 g-lg-5 checkout-page-row">
          <div className="col-lg-5 position-relative">
            <img src={image} className="rounded" alt="heroSection" />
            <div className="position-absolute top-0 end-0 z-index-1 mt-n4">
              <div
                className="bg-blur border border-light rounded-3 text-center shadow-lg p-3"
                style={{ backgroundColor: ' rgba(255, 255, 255, 0.8)' }}
              >
                <i className="bi bi-headset text-success fs-3"></i>
                <h5 className="text-dark mb-1">24/7</h5>
                <h6 className="text-dark fw-light small mb-0">Support Team!</h6>
              </div>
            </div>
            <div className="vstack gap-5 align-items-center position-absolute top-0 start-0 d-none d-md-flex mt-5 ms-n3">
              <img
                className="icon-xl shadow-lg border border-3 border-white rounded-circle"
                src={image1}
                alt="avatar"
              />
              <img
                className="icon-xxl shadow-lg border border-3 border-white rounded-circle"
                src={image2}
                alt="avatar"
              />
            </div>
          </div>
          <div className="col-lg-7 position-relative mb-4 mb-md-0">
            <h1 className="mb-4 mt-md-5 display-5">
              Cut your business travel cost
              <span
                className="position-relative z-index-9 text-success"
                style={{ fontWeight: 600 }}
              >
                {' '}
                by 60%
              </span>
            </h1>
            <p className="mb-4 lead">
              Sign up for free now and enjoy special rates without any contracts, obligations, or
              mandatory minimum spending.
            </p>

            <Form
              className="card shadow-lg rounded-1 position-relative"
              style={{ padding: '15px 36px' }}
              onFinish={onFinish}
              form={form}
            >
              <Form.Item className="mb-0" name="email" validateTrigger={['onSubmit']}>
                <div className="d-flex">
                  <div className="input-group">
                    <Input
                      type="text"
                      placeholder="Enter your work email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      className="form-control email"
                    />
                    <button type="submit" className="btn btn-primary register-btn">
                      Register your business for free!
                    </button>
                  </div>
                </div>
              </Form.Item>
              {emailError && <div style={{ color: 'red', marginTop: '5px' }}>{emailError}</div>}
            </Form>
            <div className="row g-4 align-items-center">
              <div className="col-lg-12 mt-6">
                <h4 className="text-uppercase fw-medium savings-text-hero mb-1">
                  2023 &amp; 2024 Member
                </h4>
                <h1 className='text-uppercase fw-medium savings-text-hero'>
                <span className='h4 fw-medium mb-0 pb-1'>Savings:</span> {(!loading && !isEmpty(savings)) && (
                    <strong className="text-success h2 fade_in mb-0" id="savings">
                      ${savings}
                    </strong>
                  )}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
 